import "core-js/modules/es.number.constructor.js";
import SwiperHeightField from "@/pages/design/components/SwiperHeightField/index.vue";
export default {
  name: 'InputBarSelect',
  components: {
    SwiperHeightField: SwiperHeightField
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {}
};